import {prepareOptions} from '@/utils/helpers'

export default {
	data() {
		return {
			entityName: 'content_source',
			moduleName: 'contentSources',
			detailPageRouteName: 'contentSourceDetail',
			entity: {
				id_operator: null,
				hostname: '',
				ip: '',
				virtual: false,
				utilization_factor: 0,
				locality_ids: [],
				allow_video_data_delivery_from: null,
				allow_video_data_delivery_to: null,
				backend_config: null,
			},
			updateFields: [
				'id_operator',
				'hostname',
				'ip',
				'virtual',
				'utilization_factor',
				'locality_ids',
				'allow_video_data_delivery_from',
				'allow_video_data_delivery_to',
				'backend_config',
			],
			datetimeFields: [
				'allow_video_data_delivery_from',
				'allow_video_data_delivery_to',
			],
			fieldsToResetOnSuccess: ['hostnameref', 'ipref'],
			utilizationFactorOptions: [],
			localityOptions: [],
			localities: [],
		}
	},
	computed: {
		responsiveTabs() {
			return [
				{key: 'settings', text: this.$gettext('Základní údaje')},
				{key: 'content', text: this.$gettext('Obsah')},
			]
		},
		operatorIdComputed: {
			get() {
				let idOperator = this.entity.id_operator
				if (idOperator === null) {
					idOperator = '0'
				}
				return idOperator
			},
			set(newValue) {
				if (Number(this.entity.id_operator) !== Number(newValue)) {
					this.initLocalityOptions(newValue)
						.then(() => {
							this.setDefaultLocality(newValue)
						})
				}
				this.entity.id_operator = newValue
			}
		}
	},
	methods: {
		initUtilizationFactorOptions(setFirstValue = false) {
			this._.forEach(this._.range(11), (item) => {
				this.utilizationFactorOptions.push({id: item, text: item})
			})

			if (setFirstValue) {
				this.entity.utilization_factor = 0
			}
		},
		initLocalityOptions(idOperator = null) {
			return this.localityService.getEntities({'id_selected_operator': idOperator})
				.then(data => {
					this.localities = data['localities']
					this.localityOptions = prepareOptions(data['localities'], 'id', 'name', 'value')
				})
		},
		updateContentSourceDate(dateInfo) {
			this.entity[dateInfo.attrKey] = dateInfo.date
		},
		_beforeCreateEntityActions(params = null) {
			if (Number(params['id_operator']) === 0) {
				params['id_operator'] = null
			}
			return params
		},
		_beforeUpdateEntityActions(params = null) {
			this._.unset(params, 'id_operator')
			return params
		},
		_processDetailErrorMessage(error) {
			let hostnameError = null
			let ipError = null;
			this._.forEach(error['validation_errors'], (errorMessage) => {
				if (errorMessage === 'Content source\'s hostname must be set.') {
					hostnameError = this.$gettext('Zadejte hostname')
				}
				if (errorMessage === 'Hostname must be at least 3 characters long.') {
					hostnameError = this.$gettext('Hostname musí obsahovat min. 3 znaky')
				}
				if (this._.includes(errorMessage, 'Hostname') && this._.includes(errorMessage, 'is not unique.')) {
					hostnameError = this.$gettext('Hostname musí být unikátní')
				}
				if (errorMessage === 'Given IP address is not valid IPv4 address!') {
					ipError = this.$gettext('IP adresa musí být ve formátu IPv4')
				}
			})

			if (hostnameError !== null) {
				this.setFieldInvalid('hostnameref', true, hostnameError)
			} else {
				this.setFieldInvalid('hostnameref')
			}

			if (ipError !== null) {
				this.setFieldInvalid('ipref', true, ipError)
			} else {
				this.setFieldInvalid('ipref')
			}

			return error['error_message']
		},
		successProcessLinearContent(linearContentId = null) {
			return this.processLinearContentErrorMessage({
				'error_message': '',
				'validation_errors': [],
			}, linearContentId)
		},
		processLinearContentErrorMessage(error, linearContentId = null) {
			let templateError = null

			this._.forEach(error['validation_errors'], (errorMessage) => {
				if (errorMessage === 'Url template\'s template must be set.') {
					templateError = this.$gettext('Zadejte template URL')
				}
				if (errorMessage === 'Url template\'s template must be string.') {
					templateError = this.$gettext('Template URL musí obsahovat textovou hodnotu.')
				}
				if (this._.includes(errorMessage, 'URL template contains invalid variable')) {
					templateError = this.$gettext('Template URL obsahuje nevalidní proměnnou.')
				}
				if (this._.includes(errorMessage, 'Non adaptive url template can not contain <codec_code> variable.')) {
					templateError = this.$gettext("Neadaptivní template URL nesmí obsahovat proměnnou <codec_code>.")
				}
				if (errorMessage === "Url template with given values is not unique in content source.") {
					error['error_message'] = this.$gettext('Lineární obsah se stejnými hodnotami již ve zdroji obsahu existuje.')
				}
			})

			if (templateError !== null) {
				if (linearContentId === null) {
					this.setFieldInvalid('addtemplateref', true, templateError)
				} else {
					this.$refs[linearContentId + '-linearcontentrowref'][0]
						.setFieldInvalid(linearContentId + '-templateref', true, templateError)
				}
			} else {
				if (linearContentId === null) {
					this.setFieldInvalid('addtemplateref')
				} else {
					this.$refs[linearContentId + '-linearcontentrowref'][0]
						.setFieldInvalid(linearContentId + '-templateref')
				}
			}

			return error['error_message']
		},
		successProcessNonlinearContent(nonlinearContentId = null) {
			return this.processNonlinearContentErrorMessage({
				'error_message': '',
				'validation_errors': [],
			}, nonlinearContentId)
		},
		processNonlinearContentErrorMessage(error, nonlinearContentId = null) {
			let noSettingError = false
			let timeshiftError = null
			let catchupError = null
			let pvrError = null

			this._.forEach(error['validation_errors'], (errorMessage) => {
				if (errorMessage === 'Timeshift maximum length in minutes should be a number.' ||
					this._.includes(errorMessage, 'Timeshift maximum length in minutes must be at least') ||
					this._.includes(errorMessage, 'Timeshift maximum length in minutes must be at most')) {
					timeshiftError = this.$gettext('Chybná hodnota timeshiftu')
				}
				if (errorMessage === 'Catchup maximum length in hours should be a number.' ||
					this._.includes(errorMessage, 'Catchup maximum length in hours must be at least') ||
					this._.includes(errorMessage, 'Catchup maximum length in hours must be at most')) {
					catchupError = this.$gettext('Chybná hodnota catchupu')
				}
				if (errorMessage === 'PVR maximum length in days should be a number.' ||
					this._.includes(errorMessage, 'PVR maximum length in days must be at least') ||
					this._.includes(errorMessage, 'PVR maximum length in days must be at most')) {
					pvrError = this.$gettext('Chybná hodnota pvr')
				}
				if (errorMessage === 'Timeshift length in minutes must be set.') {
					timeshiftError = 'Timeshift musí být vyplněn.'
				}
				if (errorMessage === 'Catchup length in hours must be set.') {
					catchupError = 'Catchup musí být vyplněn.'
				}
				if (errorMessage === 'PVR length in days must be set.') {
					pvrError = 'PVR musí být vyplněn.'
				}
				if (this._.includes(errorMessage, 'Nonlinear content settings for protocol') &&
					this._.includes(errorMessage, 'already exists in content source.')) {
					error['error_message'] = this.$gettext('Nelineární obsah s vybraným protokolem na zdroji obsahu již existuje.')
				}
				if (errorMessage === "No setting provided.") {
					error['error_message'] = this.$gettext('Musíte vyplnit alespoň jednu z hodnot timeshift, catchup, pvr.')
					noSettingError = true
					return false
				}
			})

			if (noSettingError) {
				this.processSettingError('', nonlinearContentId, 'timeshift')
				this.processSettingError('', nonlinearContentId, 'catchup')
				this.processSettingError('', nonlinearContentId, 'pvr')
			} else {
				this.processSettingError(timeshiftError, nonlinearContentId, 'timeshift')
				this.processSettingError(catchupError, nonlinearContentId, 'catchup')
				this.processSettingError(pvrError, nonlinearContentId, 'pvr')
			}

			return error['error_message']
		},
		processDeleteContentErrorMessage(error) {
			this._.forEach(error['validation_errors'], (errorMessage) => {
				if (errorMessage === "Channel cannot be deleted when it is being used by services/packages.") {
					error['error_message'] = this.$gettext('Kanál nemůže být smazán, je používán balíčkem nebo službou.')
				}
			})

			return error['error_message']
		},
		processSettingError(errorMessage = null, nonlinearContentId = null, key) {
			if (errorMessage !== null) {
				if (nonlinearContentId === null) {
					this.setFieldInvalid('add' + key + 'ref', true, errorMessage)
				} else {
					this.$refs[nonlinearContentId + '-nonlinearcontentrowref'][0].setFieldInvalid(nonlinearContentId + '-' + key + 'ref', true, errorMessage)
				}
			} else {
				if (nonlinearContentId === null) {
					this.setFieldInvalid('add' + key + 'ref')
				} else {
					this.$refs[nonlinearContentId + '-nonlinearcontentrowref'][0].setFieldInvalid(nonlinearContentId + '-' + key + 'ref')
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/contentsources/contentSources.js